import { NgModule } from '@angular/core'
import { SharedModule } from '../../../core/modules/shared.module'
import { AdministrationListComponent } from './administration-list/administration-list.component'
import { AdministrationComponent } from './administration.component'
import { AdministrationService } from '../../services/administration.service'
import { AdministrationDetailsComponent } from './administration-details/administration-details.component'
import { SettingsService } from '../../services/settings.service'
import { AdministrationUsersComponent } from './administration-details/administration-users/administration-users.component'
import { AdministrationManDownDialogComponent } from './administration-details/administration-man-down-dialog/administration-man-down-dialog.component'
import { AdministrationSidenavComponent } from './administration-sidenav/administration-sidenav.component'
import { AdministrationDetailsSidenavComponent } from './administration-details/administration-detail-sidenav/administration-details-sidenav.component'
import { AdministrationDetailComponent } from './administration-details/administration-detail/administration-detail.component'
import { AdministrationDocumentsComponent } from './administration-details/administration-documents/administration-documents.component'
import { AdministrationBankaccountComponent } from './administration-details/administration-bankaccount/administration-bankaccount.component'
import { BankaccountsService } from '../../services/bankaccounts.service'
import { AdministrationBankaccountDialogComponent } from './administration-details/administration-bankaccount-dialog/administration-bankaccount-dialog.component'
import { BankService } from '../../services/bank/bank.service'
import { BillingDetailsComponent } from './administration-details/billing/billing-details.component'
import { BillingService } from '../../services/billing.service'
import { AdministrationDocumentsDownloadComponent } from './administration-details/administration-documents-download/administration-documents-download.component'

@NgModule({
  imports: [SharedModule],
  providers: [AdministrationService, SettingsService, BankaccountsService, BankService, BillingService],
  declarations: [
    AdministrationListComponent,
    AdministrationComponent,
    AdministrationDetailsComponent,
    AdministrationUsersComponent,
    AdministrationManDownDialogComponent,
    AdministrationSidenavComponent,
    AdministrationDetailsSidenavComponent,
    AdministrationDetailComponent,
    AdministrationDocumentsComponent,
    AdministrationBankaccountComponent,
    AdministrationBankaccountDialogComponent,
    BillingDetailsComponent,
    AdministrationDocumentsDownloadComponent,
  ],
  entryComponents: [AdministrationManDownDialogComponent, AdministrationBankaccountDialogComponent],
})
export class AdministrationsModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administrations.module.ts